import { render, staticRenderFns } from "./DetailBootcamp.vue?vue&type=template&id=fea0d490&scoped=true"
import script from "./DetailBootcamp.vue?vue&type=script&lang=js"
export * from "./DetailBootcamp.vue?vue&type=script&lang=js"
import style0 from "./DetailBootcamp.vue?vue&type=style&index=0&id=fea0d490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea0d490",
  null
  
)

export default component.exports